module.exports = __webpack_public_path__ + "static/media/architecturals.eb36ed34.jpg";